
<!--Main Navigation-->

  <!-- Sidebar -->
  <div class="evm-layout" [ngClass]="{'dark-theme': isDarkMode}">
    <!-- Sidebar -->
    <aside class="evm-sidebar"
           [ngClass]="{
         'collapsed': sidebarCollapsed && !isMobileView,
         'open': !sidebarCollapsed && isMobileView
       }">
      <div class="sidebar-header">
        <a class="sidebar-brand d-flex align-items-center" [routerLink]="['/home']">
          <img src="https://images.cdn-files-a.com/uploads/2190159/800_66798eb3b0ee4.png" alt="CEC Logo" class="sidebar-logo">
          <div class="sidebar-brand-text" *ngIf="!sidebarCollapsed">
            <div class="brand-title">EVM</div>
            <div class="brand-subtitle">Powered by CEC</div>
          </div>
        </a>

        <button class="sidebar-toggle-btn d-lg-none" type="button" (click)="sidebarCollapsed = !sidebarCollapsed">
          <i class="fas fa-bars"></i>
        </button>
      </div>

      <div class="sidebar-menu">
        <ul class="nav flex-column">

          <!-- Home -->
          <li class="nav-item" [ngClass]="{'active': isDropdownActive('home')}">
            <a class="sidebar-link" [routerLink]="['/home']" title="Dashboard">
              <i class="fas fa-home"></i>
              <span *ngIf="!sidebarCollapsed">Dashboard</span>
            </a>
          </li>

          <ng-container *ngIf="!authService.isExternalUser()">

          <!-- Reporting -->
          <li class="nav-item" [ngClass]="{'active': isDropdownActive('reporting')}">
            <a class="sidebar-link" [routerLink]="['/report']" title="Report">
              <i class="fas fa-chart-bar"></i>
              <span *ngIf="!sidebarCollapsed">Reports</span>
            </a>
          </li>
          <!--<li class="nav-item" *ngIf="this.authService.hasAnyRole(['client-edit'])" [ngClass]="{'open': isDropdownActive('reporting')}">
            <a class="sidebar-link has-arrow" href="javascript:void(0)" (click)="reportingMenuOpen = !reportingMenuOpen">
              <div class="d-flex align-items-center">
                <i class="fas fa-chart-bar"></i>
                <span *ngIf="!sidebarCollapsed">Reporting</span>
              </div>
              <i *ngIf="!sidebarCollapsed" class="fas fa-chevron-down sidebar-chevron" [ngClass]="{'rotated': reportingMenuOpen}"></i>
            </a>

            <div class="sidebar-submenu" *ngIf="reportingMenuOpen && !sidebarCollapsed">
              <a class="submenu-link" [routerLink]="['/report']">Reports</a>
            </div>
          </li>-->

          <!-- Workflow -->
          <li class="nav-item" [ngClass]="{'open': isDropdownActive('workflow')}">
            <a class="sidebar-link has-arrow" href="javascript:void(0)" (click)="onWorkflowClick()" title="Workflow">
              <div class="d-flex align-items-center">
                <i class="fas fa-sitemap"></i>
                <span *ngIf="!sidebarCollapsed">Workflow</span>
              </div>
              <i *ngIf="!sidebarCollapsed" class="fas fa-chevron-down sidebar-chevron" [ngClass]="{'rotated': workflowMenuOpen}"></i>
            </a>

            <div class="sidebar-submenu" *ngIf="workflowMenuOpen && !sidebarCollapsed">
              <a class="submenu-link has-arrow" (click)="workflowWorkOrderOpen = !workflowWorkOrderOpen" href="javascript:void(0)">
                <span>Work Order</span>
                <i class="fas fa-chevron-down submenu-chevron"
                   [ngClass]="{'rotated': workflowWorkOrderOpen}">
                </i>
              </a>
              <div class="sidebar-submenu-nested" *ngIf="workflowWorkOrderOpen">
                <a class="submenu-link nested" [routerLink]="['/patient']">PPO</a>
                <a class="submenu-link nested" [routerLink]="['/hmo']">HMO</a>
                <a class="submenu-link nested" [routerLink]="['/hmoRegistration']">Roster Upload</a>
              </div>
              <a class="submenu-link" [routerLink]="['/userworkarea']">User Work Area</a>
            </div>
          </li>

          <!-- Repository -->
          <li class="nav-item" [ngClass]="{'open': isDropdownActive('repository')}">
            <a class="sidebar-link has-arrow" href="javascript:void(0)" (click)="onRepositoryClick()" title="Repository">
              <div class="d-flex align-items-center">
                <i class="fas fa-folder-open"></i>
                <span *ngIf="!sidebarCollapsed">Repository</span>
              </div>
              <i *ngIf="!sidebarCollapsed" class="fas fa-chevron-down sidebar-chevron" [ngClass]="{'rotated': repositoryMenuOpen}"></i>
            </a>

            <div class="sidebar-submenu" *ngIf="repositoryMenuOpen && !sidebarCollapsed">
              <a class="submenu-link" *ngIf="this.authService.hasRole('audit-view')" [routerLink]="['/repository']">Repo</a>
              <a class="submenu-link" [routerLink]="['/conflicted']">Conflicted-Accounts</a>
            </div>
          </li>
            <!-- Audit -->
            <li class="nav-item" *ngIf="this.authService.hasAnyRole(['audit-edit'])" [ngClass]="{'open': isDropdownActive('audit')}">
                
                <a class="sidebar-link has-arrow" href="javascript:void(0)" (click)="onAuditClick()" title="Audit">
                    <div class="d-flex align-items-center">
                      <i class="fa-solid fa-chart-pie"></i>
                      <span *ngIf="!sidebarCollapsed">Audit</span>
                    </div>
                  <i *ngIf="!sidebarCollapsed" class="fas fa-chevron-down sidebar-chevron" [ngClass]="{'rotated': adminMenuOpen}"></i>
                </a>

                <div class="sidebar-submenu" *ngIf="auditMenuOpen && !sidebarCollapsed">
                  <a class="submenu-link" *ngIf="this.authService.hasRole('audit-view')" [routerLink]="['/audit/quality-governance']">Quality Governance Dashboard</a>
                  <a class="submenu-link" *ngIf="this.authService.hasRole('audit-view')" [routerLink]="['/audit/queue']">Audit Queue</a>
                </div>
            </li>

          <!-- EVM Admin -->
          <li class="nav-item" *ngIf="this.authService.hasAnyRole(['client-edit', 'audit-view', 'audit-edit'])" [ngClass]="{'open': isDropdownActive('admin')}">
            <a class="sidebar-link has-arrow" href="javascript:void(0)" (click)="onAdminClick()" title="EVM Admin">
              <div class="d-flex align-items-center">
                <i class="fas fa-user-cog"></i>
                <span *ngIf="!sidebarCollapsed">EVM Admin</span>
              </div>
              <i *ngIf="!sidebarCollapsed" class="fas fa-chevron-down sidebar-chevron" [ngClass]="{'rotated': adminMenuOpen}"></i>
            </a>

            <div class="sidebar-submenu" *ngIf="adminMenuOpen && !sidebarCollapsed">
              <a class="submenu-link" *ngIf="this.authService.hasRole('staff-view')" [routerLink]="['/provider']">Staff Enrollment</a>
              <a class="submenu-link" *ngIf="this.authService.hasRole('client-view')" [routerLink]="['/client']">Client Registration</a>
              <a class="submenu-link" *ngIf="this.authService.hasRole('office-view')" [routerLink]="['/office']">Offices</a>
              <a class="submenu-link" *ngIf="this.authService.hasRole('user-view')" [routerLink]="['/user']">User Master</a>
              <a class="submenu-link" *ngIf="this.authService.hasRole('rule-view')" [routerLink]="['/rules']">Rules Registration</a>
              <a class="submenu-link" [routerLink]="['/questions']">Questions</a>
              <a class="submenu-link" [routerLink]="['/payer']">Payers</a>
              <a
                class="submenu-link"
                *ngIf="this.authService.hasAnyRole(['audit-view', 'audit-edit'])"
                [routerLink]="['/audit/severity-configuration']">
                Severity Configuration
              </a>
              <a
                class="submenu-link"
                *ngIf="this.authService.hasAnyRole(['audit-view', 'audit-edit'])"
                [routerLink]="['/audit/error-configuration']">
                Error Configuration
              </a>
            </div>
          </li>

          <!-- Mail Service -->
          <li class="nav-item" *ngIf="this.authService.hasAnyRole(['client-edit'])" [ngClass]="{'open': isDropdownActive('mail')}">
            <a class="sidebar-link has-arrow" href="javascript:void(0)" (click)="onMailClick()" title="Mail">
              <div class="d-flex align-items-center">
                <i class="fa-solid fa-inbox"></i>
                <span *ngIf="!sidebarCollapsed">Mail</span>
              </div>
              <i *ngIf="!sidebarCollapsed" class="fas fa-chevron-down sidebar-chevron" [ngClass]="{'rotated': mailMenuOpen}"></i>
            </a>

            <div class="sidebar-submenu" *ngIf="mailMenuOpen && !sidebarCollapsed">
              <!-- <a class="submenu-link" *ngIf="this.authService.hasRole('client-edit')" [routerLink]="['/inbox']">Inbox</a> -->
              <a class="submenu-link" *ngIf="this.authService.hasRole('client-edit')" [routerLink]="['/smtpConfig']">SMTP Config</a>
            </div>
          </li>


          <!-- Extractor Service -->
          <li class="nav-item" *ngIf="this.authService.hasAnyRole(['client-edit'])" [ngClass]="{'open': isDropdownActive('extractor')}">
            <a class="sidebar-link has-arrow" href="javascript:void(0)" (click)="onExtractorClick()" title="extractor">
              <div class="d-flex align-items-center">
                <i class="fa-solid fa-gears"></i>
                <span *ngIf="!sidebarCollapsed">Extractor</span>
              </div>
              <i *ngIf="!sidebarCollapsed" class="fas fa-chevron-down sidebar-chevron" [ngClass]="{'rotated': extractorMenuOpen}"></i>
            </a>

            <div class="sidebar-submenu" *ngIf="extractorMenuOpen && !sidebarCollapsed">
              <a class="submenu-link" *ngIf="this.authService.hasRole('client-edit')" [routerLink]="['/extractor']">Run Extractor</a>
              <a class="submenu-link" *ngIf="this.authService.hasRole('client-edit')" [routerLink]="['/pasting']">Pasting</a>
              <a class="submenu-link" *ngIf="this.authService.hasRole('client-edit')" [routerLink]="['/emailAutomation']">EOD Report</a>
              <a class="submenu-link" *ngIf="this.authService.hasRole('client-edit')" [routerLink]="['/extractorReport']">Extractor Report</a>
            </div>
          </li>

          <!-- SOP / Guidelines -->
          <li class="nav-item" [ngClass]="{'active': isDropdownActive('guidelines')}">
            <a class="sidebar-link" [routerLink]="['/guidelines']" title="SOP / Guidelines">
              <i class="fa-solid fa-book-open"></i>
              <span *ngIf="!sidebarCollapsed">SOP / Guidelines</span>
            </a>
          </li>

          

          </ng-container>

          <!-- Settings -->
          <!--<li class="nav-item">
            <a class="sidebar-link" href="javascript:void(0)" (click)="openModal()">
              <i class="fas fa-cog"></i>
              <span *ngIf="!sidebarCollapsed">Settings</span>
            </a>
          </li>-->
        </ul>
      </div>
    </aside>

    <!-- Main area -->
    <div class="evm-main" [ngClass]="{'expanded': sidebarCollapsed}">
      <!-- Top utility bar -->
      <div class="evm-topbar">
        <div class="topbar-left">
          <button class="sidebar-toggle-btn topbar-desktop-toggle" type="button" (click)="toggleSidebar()">
            <i class="fas fa-bars"></i>
          </button>

          <button class="sidebar-toggle-btn topbar-mobile-toggle" type="button" (click)="toggleSidebar()">
            <i class="fas fa-bars"></i>
          </button>
        </div>

        <div class="topbar-right">
          <!-- Theme Toggle -->
          <div class="theme-toggle modern-theme-toggle" (click)="toggleTheme()" title="Toggle Theme">
            <div class="theme-toggle-track" [ngClass]="{'active': isDarkMode}">
              <div class="theme-toggle-thumb" [ngClass]="{'active': isDarkMode}">
                <i class="fas fa-sun sun-icon" [ngClass]="{'hidden': isDarkMode}"></i>
                <i class="fas fa-moon moon-icon" [ngClass]="{'visible': isDarkMode}"></i>
              </div>
            </div>
          </div>

          <!-- Stats -->
          <div class="dropdown" *ngIf="!authService.isExternalUser()">
            <a class="topbar-icon-btn topbar-stat-btn dropdown-toggle" id="statsDropdown"
               data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" href="javascript:void(0)">
              <i class="fa-solid fa-chart-simple"></i>
              <span>Stats</span>
            </a>

            <div class="dropdown-menu dropdown-menu-right p-3 stats-dropdown-modern" aria-labelledby="statsDropdown" style="min-width: 320px;">
              <div class="d-flex flex-wrap justify-content-between text-center">
                <div class="stat-box">
                  <i class="fas fa-users text-primary mb-1"></i>
                  <div class="stat-label">Total</div>
                  <div class="stat-value">{{ stats.totalCount }}</div>
                </div>
                <div class="stat-box">
                  <i class="fas fa-user-check text-warning mb-1"></i>
                  <div class="stat-label">Assigned</div>
                  <div class="stat-value">{{ stats.totalAssigned }}</div>
                </div>
                <div class="stat-box">
                  <i class="fas fa-shield-alt text-success mb-1"></i>
                  <div class="stat-label">Verified</div>
                  <div class="stat-value">{{ stats.totalVerified }}</div>
                </div>
                <div class="stat-box">
                  <i class="fas fa-times-circle text-danger mb-1"></i>
                  <div class="stat-label">Not Verified</div>
                  <div class="stat-value">{{ stats.totalNotVerified }}</div>
                </div>
                <div class="stat-box">
                  <i class="fa-regular fa-clock text-info mb-1"></i>
                  <div class="stat-label">Pending</div>
                  <div class="stat-value">{{ stats.totalPending }}</div>
                </div>
                <div class="stat-box">
                  <i class="fas fa-tasks text-secondary mb-1"></i>
                  <div class="stat-label">Backlog</div>
                  <div class="stat-value">{{ stats.totalBacklog }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Notifications -->
          <div
            class="notification-wrapper"
            (click)="$event.stopPropagation()">

            <button
              type="button"
              class="topbar-icon-btn notification-bell-btn"
              aria-label="Notifications"
              title="Notifications"
              (click)="toggleNotificationDropdown($event)">

              <i class="fas fa-bell"></i>

              <span
                *ngIf="unreadNotificationCount > 0"
                class="notification-count-badge">
                {{
                  unreadNotificationCount > 99
                    ? '99+'
                    : unreadNotificationCount
                }}
              </span>
            </button>

            <div
              *ngIf="notificationDropdownOpen"
              class="notification-dropdown">

              <div class="notification-header">
                <div>
                  <h6 class="notification-heading">
                    Notifications
                  </h6>

                  <span class="notification-count">
                    {{ unreadNotificationCount }} unread
                  </span>
                </div>

                <button
                  *ngIf="unreadNotificationCount > 0"
                  type="button"
                  class="mark-all-btn"
                  [disabled]="markAllNotificationsLoading"
                  (click)="markAllNotificationsAsRead($event)">

                  {{
                    markAllNotificationsLoading
                      ? 'Marking...'
                      : 'Mark all as read'
                  }}
                </button>
              </div>

              <div
                class="notification-list"
                (scroll)="onNotificationScroll($event)">

                <button
                  *ngFor="
                    let notification of notifications;
                    trackBy: trackByNotificationId
                  "
                  type="button"
                  class="notification-item"
                  [class.notification-unread]="!notification.read"
                  (click)="openNotification(notification, $event)">

                  <span
                    class="notification-icon"
                    [ngClass]="{
                      'notification-icon-assigned':
                        notification.notificationType === 'PATIENT_ASSIGNED',
                      'notification-icon-created':
                        notification.notificationType === 'PATIENT_CREATED',
                      'notification-icon-verified':
                        notification.notificationType === 'PATIENT_VERIFIED'
                    }">

                    <i
                      class="fas"
                      [ngClass]="{
                        'fa-user-check':
                          notification.notificationType === 'PATIENT_ASSIGNED',
                        'fa-user-plus':
                          notification.notificationType === 'PATIENT_CREATED',
                        'fa-check':
                          notification.notificationType === 'PATIENT_VERIFIED'
                      }">
                    </i>
                  </span>

                  <span class="notification-content">
                    <span class="notification-title-row">
                      <span class="notification-title">
                        {{ notification.title }}
                      </span>

                      <span
                        *ngIf="!notification.read"
                        class="notification-unread-dot">
                      </span>
                    </span>

                    <span class="notification-message">
                      {{ notification.message }}
                    </span>

                    <span class="notification-time">
                      <i class="far fa-clock"></i>
                      {{
                        notification.eventTime
                          | date:'MMM d, y, h:mm a'
                      }}
                    </span>
                  </span>
                </button>

                <div
                  *ngIf="notificationHistoryLoading"
                  class="notification-history-loading">

                  <i class="fas fa-spinner fa-spin"></i>
                  Loading notifications...
                </div>

                <div
                  *ngIf="
                    notificationHistoryInitialized &&
                    !notificationHistoryLoading &&
                    (!notifications || notifications.length === 0)
                  "
                  class="notification-empty">

                  <span class="notification-empty-icon">
                    <i class="far fa-bell"></i>
                  </span>

                  <span class="notification-empty-title">
                    No notifications
                  </span>

                  <span class="notification-empty-message">
                    You are all caught up.
                  </span>
                </div>

                <div
                  *ngIf="
                    notificationHistoryInitialized &&
                    notificationHistoryLastPage &&
                    notifications &&
                    notifications.length > notificationPageSize
                  "
                  class="notification-history-end">
                  You have reached the end.
                </div>

              </div>
            </div>
          </div>

          <div
            *ngIf="
              notificationPopups &&
              notificationPopups.length > 0
            "
            class="live-notification-container">

            <div
              *ngFor="
                let notification of notificationPopups;
                trackBy: trackByNotificationId
              "
              class="live-notification-popup"
              [class.live-notification-unread]="
                !notification.read
              "
              role="alert">

              <button
                type="button"
                class="live-notification-body"
                (click)="
                  openNotificationPopup(
                    notification,
                    $event
                  )
                ">

                <span
                  class="live-notification-icon"
                  [ngClass]="{
                    'notification-icon-assigned':
                      notification.notificationType ===
                      'PATIENT_ASSIGNED',

                    'notification-icon-created':
                      notification.notificationType ===
                      'PATIENT_CREATED',

                    'notification-icon-verified':
                      notification.notificationType ===
                      'PATIENT_VERIFIED'
                  }">

                  <i
                    class="fas"
                    [ngClass]="{
                      'fa-user-check':
                        notification.notificationType ===
                        'PATIENT_ASSIGNED',

                      'fa-user-plus':
                        notification.notificationType ===
                        'PATIENT_CREATED',

                      'fa-check':
                        notification.notificationType ===
                        'PATIENT_VERIFIED'
                    }">
                  </i>
                </span>

                <span class="live-notification-content">
                  <span class="live-notification-label">
                    New notification
                  </span>

                  <span class="live-notification-title">
                    {{ notification.title }}
                  </span>

                  <span class="live-notification-message">
                    {{ notification.message }}
                  </span>

                  <span class="live-notification-time">
                    <i class="far fa-clock"></i>

                    {{
                      notification.eventTime
                        | date:'MMM d, h:mm a'
                    }}
                  </span>
                </span>
              </button>

              <button
                type="button"
                class="live-notification-close"
                aria-label="Close notification"
                (click)="
                  dismissNotificationPopup(
                    notification.id,
                    $event
                  )
                ">

                <i class="fas fa-times"></i>
              </button>

              <span class="live-notification-progress">
              </span>
            </div>
          </div>
          <!-- Client Switch -->
          <div
            class="topbar-client-switch-card d-flex align-items-center"
            *ngIf="authService.userType === 'INTERNAL' || 'EXTERNAL'"
          >
            <span class="client-switch-icon">
              <i class="fas fa-random"></i>
            </span>

            <select
              *ngIf="clientListLoaded"
              class="form-control client-switch-select"
              name="clientSwitch"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="selectedClient"
              (ngModelChange)="onClientChange($event)"
            >
              <option
                *ngFor="let client of clientList; trackBy: trackByClientId"
                [ngValue]="client.id"
              >
                {{ client.name }}
              </option>
            </select>
          </div>

          <!-- User -->
          <div class="dropdown">
            <a class="user-pill d-flex align-items-center" id="userProfileDropdown" data-toggle="dropdown" aria-expanded="false" href="javascript:void(0)">
              <span class="user-name d-none d-sm-inline">{{ userName }}</span>
              <img src="https://cdn.pixabay.com/photo/2025/05/24/12/40/whale-9619752_1280.png" (error)="onImageError($event)" alt="User" class="user-avatar">
            </a>

            <div class="dropdown-menu dropdown-menu-right user-dropdown-menu dropdown-modern" aria-labelledby="userProfileDropdown">
              <!-- <a class="dropdown-item" href="#">
                <i class="fas fa-project-diagram"></i> New project
              </a> -->
              <a class="dropdown-item" href="javascript:void(0)" (click)="openModal()">
                <i class="fas fa-cog"></i> Settings
              </a>
              <a class="dropdown-item" (click)="openProfile()">
                <i class="fas fa-user-circle"></i> Profile
              </a>
              <div class="dropdown-divider"></div>
              <button *ngIf="isLoggedIn" class="btn btn-danger btn-block btn-sm logout-btn" (click)="logout()">
                <i class="fas fa-sign-out-alt"></i> Logout
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- page content goes here later -->
      <div class="evm-page-content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
  <!-- Navbar -->

<!--Main Navigation-->

<!--Main layout-->
<!-- <main style="margin-top: 58px;">
  <div class="container pt-4"></div>
</main> -->
<!--Main layout-->
<div *ngIf="showResetPasswordModal" #resetPassword class="app-modal-backdrop" tabindex="-1" role="dialog">
  <div class="app-modal-dialog app-modal-md" role="document">
    <div class="app-modal-content">

      <div class="app-modal-header">
        <div>
          <h3 class="app-modal-title">Reset Password</h3>
          <p class="app-modal-subtitle">Update your account password securely.</p>
        </div>

        <button type="button" class="app-modal-close" aria-label="Close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="app-modal-body">
        <form [formGroup]="resetPasswordForm">
          <div class="row">
            <div class="col-12">
              <div class="app-form-group">
                <mat-form-field appearance="outline" class="app-full-width">
                  <mat-label>User Name</mat-label>
                  <input
                    matInput
                    formControlName="userName"
                    minlength="3"
                    pmNoSpace
                    title="Name at least has 3 characters !">

                  <mat-error *ngIf="resetPasswordForm.controls.userName.errors?.required">
                    This field is required!
                  </mat-error>
                  <mat-error *ngIf="resetPasswordForm.controls.userName?.value">
                    Name must have at least 3 characters!
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="col-12">
              <div class="app-form-group">
                <mat-form-field appearance="outline" class="app-full-width">
                  <mat-label>Current Password</mat-label>
                  <input
                    matInput
                    [type]="hidePassword ? 'password' : 'text'"
                    formControlName="currentPassword"
                    pmNoSpace
                    pmPasswordPattern
                    placeholder="Enter Password">

                  <button
                    *ngIf="resetPasswordForm.controls.currentPassword.value"
                    mat-icon-button
                    matSuffix
                    type="button"
                    (click)="togglePasswordVisibility(1)">
                    <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>

                  <mat-error *ngIf="resetPasswordForm.controls.currentPassword.errors?.required">
                    This field is required!
                  </mat-error>
                  <mat-error *ngIf="resetPasswordForm.controls.currentPassword.errors?.pattern">
                    Password must be at least 8 characters, contain an uppercase letter, a lowercase letter, a number, and a special character.
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="col-12">
              <div class="app-form-group">
                <mat-form-field appearance="outline" class="app-full-width">
                  <mat-label>New Password</mat-label>
                  <input
                    matInput
                    [type]="hideNewPassword ? 'password' : 'text'"
                    formControlName="newPassword"
                    pmNoSpace
                    pmPasswordPattern
                    placeholder="Enter Password">

                  <button
                    *ngIf="resetPasswordForm.controls.newPassword.value"
                    mat-icon-button
                    matSuffix
                    type="button"
                    (click)="togglePasswordVisibility(2)">
                    <mat-icon>{{ hideNewPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>

                  <mat-error *ngIf="resetPasswordForm.controls.newPassword.errors?.required">
                    This field is required!
                  </mat-error>
                  <mat-error *ngIf="resetPasswordForm.controls.newPassword.errors?.pattern">
                    Password must be at least 8 characters, contain an uppercase letter, a lowercase letter, a number, and a special character.
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="col-12">
              <div class="app-form-group">
                <mat-form-field appearance="outline" class="app-full-width">
                  <mat-label>Confirm Password</mat-label>
                  <input
                    matInput
                    [type]="hideConfirmPassword ? 'password' : 'text'"
                    formControlName="confirmPassword"
                    pmNoSpace
                    pmPasswordPattern
                    placeholder="Enter Password">

                  <button
                    *ngIf="resetPasswordForm.controls.confirmPassword.value"
                    mat-icon-button
                    matSuffix
                    type="button"
                    (click)="togglePasswordVisibility(3)">
                    <mat-icon>{{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>

                  <mat-error *ngIf="resetPasswordForm.controls.confirmPassword.errors?.required">
                    This field is required!
                  </mat-error>
                  <mat-error *ngIf="resetPasswordForm.get('confirmPassword')?.invalid">
                    Password must match.
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="app-modal-footer">
        <button type="button" class="btn app-btn app-btn-secondary" (click)="closeModal()">Close</button>
        <button type="submit" class="btn app-btn app-btn-primary" (click)="onSubmit()">Reset Password</button>
      </div>

    </div>
  </div>
</div>

<!--<div *ngIf="this.authService.clientId === null" class="client-modal-overlay">
    <div #CId class="modal-i" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title">Select Client</h3>
                </div>
                <div class="modal-body">
                    <form [formGroup]="cIdForm">
                        <div class="row">
                            <div class="col-xl-12 col-md-12 ">
                                <div class="form-group">
                                    <mat-form-field appearance="outline">
                                        <mat-label>Select Client</mat-label>
                                        <mat-select formControlName="clientId" class="text-primary">
                                            <mat-option *ngIf="!clientListLoaded">Loading clients...</mat-option>
                                            <mat-option class="text-primary"
                                                        *ngFor="let items of clientList"
                                                        [value]="items.id">{{items.name}}</mat-option>
                                        </mat-select>
                                        <mat-error
                                                *ngIf="cIdForm.controls.clientId.errors?.required">
                                            This field is required!
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" (click)="closeModali();this.authService.logout()">Back
                        to login
                    </button>
                    <button type="submit" class="btn btn-primary" (click)="onSubmitC()">Submit</button>
                </div>
            </div>
        </div>
    </div>
</div>-->

<div *ngIf="this.authService.clientId === null" class="client-modal-overlay">
  <!-- Show loader until data arrives -->
  <!-- <div *ngIf="!clientListLoaded" class="client-loading">
    <div class="loader"></div>
    <p>Loading clients...</p>
  </div> -->
  <!-- Show modal ONLY when ready -->
  <div *ngIf="clientListLoaded && showClientModal" class="client-modal-card">

    <div class="client-modal-header">
      <h2>Select Client</h2>
      <p>Please choose a client to continue</p>
    </div>

    <div class="client-modal-body">
      <form [formGroup]="cIdForm">

        <mat-form-field appearance="outline" class="client-form-field">
          <mat-label>Select Client</mat-label>

          <mat-select
            formControlName="clientId"
            panelClass="client-select-panel">

            <mat-option *ngIf="!clientListLoaded">Loading clients...</mat-option>

            <mat-option *ngFor="let items of clientList" [value]="items.id">
              {{ items.name }}
            </mat-option>

          </mat-select>

          <mat-error *ngIf="cIdForm.controls.clientId.errors?.required">
            This field is required!
          </mat-error>

        </mat-form-field>

      </form>
    </div>

    <div class="client-modal-footer">
      <button class="btn btn-light" (click)="closeModalAndLogout()">
        Back
      </button>

      <button class="btn btn-primary" (click)="onSubmitC()">
        Continue
      </button>
    </div>

  </div>
</div>


<!-- Welcome splash overlay -->
<div *ngIf="welcomeVisible" class="welcome-overlay">

  <div class="welcome-box">
    <div class="welcome-logo">
      <img src="assets/img/CEC%20logo.png" alt="logo">
    </div>

    <h2>Welcome to EVM</h2>
    <p>Preparing your dashboard...</p>

    <!-- Loader -->
    <div class="loader-bar">
      <div class="loader-progress"></div>
    </div>
  </div>

</div>

<div *ngIf="showUserProfileModal" #userProfile class="app-modal-backdrop" tabindex="-1" role="dialog">
  <div class="app-modal-dialog app-modal-md" role="document">
    <div class="app-modal-content">
      <div class="app-modal-header">
        <h3 class="app-modal-title">User Profile</h3>
        <button type="button" class="app-modal-close" aria-label="Close" (click)="closeProfile()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="app-modal-body">
        <form [formGroup]="userProfileForm">
          <div class="row">
            <!-- Profile Image Upload -->
            <div class="col-12 text-center">
              <div class="profile-image-container">
                <img [src]="profileImage || 'https://cdn.pixabay.com/photo/2025/05/24/12/40/whale-9619752_1280.png'" class="user-avatar" (error)="onImageError($event)" alt="Profile">
                <input type="file" #fileInput hidden (change)="onFileSelected($event)">
                <button mat-icon-button class="edit-icon" (click)="fileInput.click()">
                  <mat-icon>edit</mat-icon>
                </button>
              </div>
            </div>

            <!-- First Name -->
            <div class="col-md-12">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>First Name</mat-label>
                <input matInput formControlName="firstName">
                <mat-error *ngIf="userProfileForm.controls.firstName.errors?.required">
                  This field is required!
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Last Name -->
            <div class="col-md-12">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Last Name</mat-label>
                <input matInput formControlName="lastName">
                <mat-error *ngIf="userProfileForm.controls.lastName.errors?.required">
                  This field is required!
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Email -->
            <div class="col-md-12">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Email</mat-label>
                <input matInput type="email" formControlName="email">
                <mat-error *ngIf="userProfileForm.controls.email.errors?.required">
                  This field is required!
                </mat-error>
                <mat-error *ngIf="userProfileForm.controls.email.errors?.email">
                  Enter a valid email!
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Role -->
            <div class="col-md-12">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Role</mat-label>
                <input matInput type="text" formControlName="role">
              </mat-form-field>
            </div>

            <!-- Designation -->
            <div class="col-md-12">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Designation</mat-label>
                <input matInput formControlName="designation">
              </mat-form-field>
            </div>
          </div>
        </form>
      </div>
      <div class="app-modal-footer">
        <button type="submit" class="btn app-btn app-btn-secondary" (click)="onSubmitUserProfile()">Save</button>
        <button type="button" class="btn app-btn app-btn-secondary" (click)="closeProfile()">Close</button>
      </div>
    </div>
  </div>
</div>
